/**
 * Enum for inventory item assignment statuses
 */
var AssignmentStatus;
(function (AssignmentStatus) {
    AssignmentStatus["AVAILABLE"] = "available";
    AssignmentStatus["SOFT_LOCKED"] = "softLocked";
    AssignmentStatus["HARD_LOCKED"] = "hardLocked";
    AssignmentStatus["SOLD"] = "sold";
    AssignmentStatus["UNAVAILABLE"] = "unavailable";
    AssignmentStatus["UNKNOWN"] = "unknown";
    // Add new statuses here in the future
})(AssignmentStatus || (AssignmentStatus = {}));

export { AssignmentStatus };
//# sourceMappingURL=Assignment.js.map
